export default __webpack_public_path__ + "static/media/codepen.d12307c5.png";